<div class="listview-item bg-lightest mb-3">
  <div class="row">
    <div class="col-2 d-flex flex-column">
      <div>
        <i
          class="fa-regular me-2"
          [ngbTooltip]="
            !!assignmentDate.shift
              ? ('shiftTimes.labelLong.' + assignmentDate.shift | baseBusinessKey | translate)
              : !!assignmentDate.workShift
              ? ('shiftTimes.flex' | translate) +
                ' (' +
                ('shiftTimes.labelLong.' + assignmentDate.workShift | baseBusinessKey | translate) +
                ')'
              : ('shiftTimes.flex' | translate)
          "
          [ngClass]="{
            'fa-sunrise': assignmentDate.shift === shiftTypes.FD,
            'fa-sun-bright': assignmentDate.shift === shiftTypes.ZD,
            'fa-clock': assignmentDate.shift === shiftTypes.SD,
            'fa-moon-stars': assignmentDate.shift === shiftTypes.ND,
            'fa-user-clock': !assignmentDate.shift
          }"
        ></i>
        <b
          >{{
            (!!assignmentDate.shift
              ? ('shiftTimes.label.' + assignmentDate.shift | baseBusinessKey)
              : 'shiftTimes.flex'
            ) | translate
          }}
          <span *ngIf="!assignmentDate.shift && assignmentDate.workShift"
            >({{ 'shiftTimes.label.' + assignmentDate.workShift | baseBusinessKey | translate }})</span
          ></b
        >
      </div>
      <span>{{ assignmentDate.date | baseFormatDate }}</span>
    </div>
    <div class="col d-flex flex-column">
      <div
        class="time-recordings-text-line required-line"
        *ngIf="!!assignmentDate.shift || !!assignmentDate.workShift"
      >
        <span>{{ 'work.target' | translate }}:</span>
        <span>{{ targetShiftTime?.startTime }}</span>
      </div>
      <div class="time-recordings-text-line">
        <span>{{ 'work.actual' | translate }}:</span>
        <span *ngIf="getTimeRange(assignmentDate, true) as startTime; else emptyField">{{ startTime }}</span>
      </div>
    </div>
    <div class="col d-flex flex-column">
      <div
        class="time-recordings-text-line required-line"
        *ngIf="!!assignmentDate.shift || !!assignmentDate.workShift"
      >
        <span>{{ 'work.target' | translate }}:</span>
        <span>{{ targetShiftTime?.endTime }}</span>
      </div>
      <div class="time-recordings-text-line">
        <span>{{ 'work.actual' | translate }}:</span>
        <span *ngIf="getTimeRange(assignmentDate, false) as endTime; else emptyField">{{ endTime }}</span>
      </div>
    </div>
    <div class="col d-flex flex-column">
      <div
        class="time-recordings-text-line required-line"
        *ngIf="assignmentDate.shift"
      >
        <span>{{ 'work.target' | translate }}:</span>
        <span>{{ assignmentDate.targetTimePresent | baseMinutesToHours }}</span>
      </div>
      <div class="time-recordings-text-line">
        <span>{{ 'work.actual' | translate }}:</span>
        <span *ngIf="assignmentDate.timePresent > 0; else emptyField">{{
          assignmentDate.timePresent | baseMinutesToHours
        }}</span>
      </div>
    </div>
    <div class="col d-flex flex-column">
      <div class="time-recordings-text-line">
        <span *ngIf="assignmentDate.timeBreak > 0; else emptyField">{{
          assignmentDate.timeBreak | baseMinutesToHours
        }}</span>
      </div>
    </div>
    <div class="col d-flex flex-column">
      <div
        class="time-recordings-text-line required-line"
        *ngIf="assignmentDate.shift"
      >
        <span>{{ 'work.target' | translate }}:</span>
      </div>
      <div class="time-recordings-text-line">
        <span>{{ 'work.actual' | translate }}:</span>
        <span *ngIf="assignmentDate.timeWork > 0; else emptyField">{{
          assignmentDate.timeWork | baseMinutesToHours
        }}</span>
      </div>
    </div>
    <div class="col-3 d-flex align-items-center">
      <base-button
        *ngIf="canBeReleased"
        label="externalEmployees.timeRecordings.release"
        color="primary"
        (btnClick)="handleShowConfirmPopup(assignmentDate.id)"
      ></base-button>
      <span
        *ngIf="!canBeReleased"
        [ngbTooltip]="assignmentDate.status === assignmentDateStatus.ACCEPTED ? signedTooltip : undefined"
        (mouseover)="tooltipAssignmentDate = assignmentDate"
        class="fw-bold"
        [ngClass]="{
          'employee-time-recordings-state-signed': assignmentDate.status === assignmentDateStatus.ACCEPTED,
          'employee-time-recordings-state-unsigned': assignmentDate.status === assignmentDateStatus.SUBMITTED,
          'employee-time-recordings-state-open': assignmentDate.status === assignmentDateStatus.OPEN,
          'employee-time-recordings-state-canceled': assignmentDate.status === assignmentDateStatus.CANCELED
        }"
        >{{ 'externalEmployees.timeRecordings.' + assignmentDate.status | translate }}</span
      >
    </div>
  </div>
</div>

<ng-template #emptyField>
  <span>-</span>
</ng-template>

<ng-template #confirmPopup>
  <p>{{ 'operations.confirm.timesheet' | translate }}</p>
</ng-template>

<ng-template #signedTooltip>
  <div
    *ngIf="assignmentDate.signature.data"
    class="employee-time-recordings-signature"
  >
    <div class="employee-time-recordings-signature-container">
      <span class="employee-time-recordings-signature-image-wrapper">
        <img
          [src]="assignmentDate.signature.data"
          alt="signature-image"
          class="employee-time-recordings-signature-image"
        />
      </span>
    </div>
  </div>
  <div class="d-flex flex-column">
    <span class="fw-bold">{{ tooltipAssignmentDate.signedByName }}</span>
    <span>{{ tooltipAssignmentDate.signedOn | baseFormatDate: true }} {{ 'dateTime.hour' | translate }}</span>
  </div>
</ng-template>
